import {
  getPvSalesIndex,
  getEnergySalesIndex,
  getPvSalesChart,
} from "@/api/panel";
import { Chart } from "@/utils/charts";

export default {
  namespaced: true,
  state: {
    options: {},
    aboutAll: {
      monthIndex: {},
      shareIndex: {},
      totalIndex: {},
    },
    aboutEnergy: {
      monthIndex: {},
      shareIndex: {},
      totalIndex: {},
    },
  },
  mutations: {
    SET_PV_SALES_INDEX: (state, data) => {
      state.aboutAll = data;
    },
    SET_ENERGY_SALES_INDEX: (state, data) => {
      state.aboutEnergy = data;
    },
    SET_PV_SALES_CHART: (state, data) => {
      state.options = data;
    },
  },
  actions: {
    getPvSalesIndex({ commit, state }, { dataSource }) {
      if (Object.keys(state.aboutAll.monthIndex).length > 0) return;
      getPvSalesIndex({
        dataSource,
      }).then((response) => {
        const { data } = (response && response.data) || {};
        if (data) commit("SET_PV_SALES_INDEX", data || {});
      });
    },

    getEnergySalesIndex({ commit, state }, { dataSource }) {
      if (Object.keys(state.aboutEnergy.monthIndex).length > 0) return;
      getEnergySalesIndex({
        dataSource,
      }).then((response) => {
        const { data } = (response && response.data) || {};
        if (data) commit("SET_ENERGY_SALES_INDEX", data || []);
      });
    },
    getPvSalesChart({ commit, state }, { dataSource }) {
      if (Object.keys(state.options).length > 0) return;
      getPvSalesChart({
        dataSource,
      }).then((response) => {
        const { data } = (response && response.data) || {};
        if (!data) return;
        const options = new Chart("bar", data || [], {
          color: ["#ff5656", "#2FC25B", "#F2F3F5", "#507CFF", "#DFE0E5"],
          barMaxWidth: 10,
          barGap: 0,
          grid: {
            left: 20,
            right: 20,
            top: 65,
            bottom: 32,
          },
          legend: {
            itemWidth: 8,
            itemHeight: 8,
            top: 10,
          },
          yAxis: [
            {
              name: "",
              axisLabel: {
                show: false,
              },
              max: (value) => {
                return value.max * 2.2;
              },
            },
            {
              name: "",
              splitLine: {
                show: false,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
              },
              axisLabel: {
                show: false,
              },
              min: (value) => {
                return value.max - (value.max - value.min) * 2.5;
              },
              max: (value) => value.max,
            },
          ],
          field: { type: "normal", unit: "万辆" },
          fields: [
            { name: "同比", type: "percent" },
            { name: "环比", type: "percent" },
          ],
        }).getChart();
        commit("SET_PV_SALES_CHART", options);
      });
    },
  },
};
